getUrlParameter = (sParam) ->
  sPageURL = decodeURIComponent(window.location.search.substring(1))
  sURLVariables = sPageURL.split('&')

  for sURLVariable in sURLVariables
    sParameterName = sURLVariable.split('=')
    if sParameterName[0] == sParam
      # return sParameterName[1] === undefined ? true : sParameterName[1];
      return sParameterName[0]
  return

if getUrlParameter('newark')
  #load cities without cache
  $.ajax(url: '/event/ajax-nearby-cities?type=1&buy-tickets-tab=1&count=3&from=' + window.myvars.serverRemoteAddr).done (html) ->
    $('#bottom-nearby-tips').html html
    return